<template>
  <div>
    <div class="blackLayer" v-show="layer_show">
      <div class="downLayer">
        <a href="javascript:;" @click="hide()"></a><b>{{ advert.title }}</b>
        <p><img :src="advert.logo" /></p>
      </div>
    </div>
    <div class="top">
      <dl>
        <dt>汽车产销概览</dt>
        <dd>
          <a href="javascript:;" @click="menu_show = !menu_show" class="more"
            ><span>更多</span></a
          >
        </dd>
      </dl>
      <div class="blackbg" v-show="menu_show" @click="menu_show = false">
        <div class="tabList">
          <span>数据类型：</span>
          <ul>
            <li :class="data_type === 'origin' ? 'onCur' : ''">
            <router-link
              tag="a"
              :to="
                '/publicity-origin-' +
                frequency +
                '-' +
                start_year +
                '-' +
                time_type
              "
              >按派系</router-link
            >
          </li>
          <li :class="data_type === 'manufacturer' ? 'onCur' : ''">
            <router-link
              tag="a"
              :to="
                '/publicity-manufacturer-' +
                frequency +
                '-' +
                start_year +
                '-' +
                time_type
              "
              >按车企</router-link
            >
          </li>
          <li :class="data_type === 'modelline' ? 'onCur' : ''">
            <router-link
              tag="a"
              :to="
                '/publicity-modelline-' +
                frequency +
                '-' +
                start_year +
                '-' +
                time_type
              "
              >按车系</router-link
            >
          </li>
          <li :class="data_type === 'brand' ? 'onCur' : ''">
            <router-link
              tag="a"
              :to="
                '/publicity-brand-' +
                frequency +
                '-' +
                start_year +
                '-' +
                time_type
              "
              >按品牌</router-link
            >
          </li>
          </ul>
          <span>时间类型：</span>
          <ul>
            <li :class="time_type === 'year' ? 'onCur' : ''"><router-link tag="a" :to="'/publicity-' + data_type + '-' + frequency + '-' + start_year + '-year'">按年</router-link></li>
            <li :class="time_type === 'quarter' ? 'onCur' : ''"><router-link tag="a" :to="'/publicity-' + data_type + '-' + frequency + '-' + start_year + '-quarter'">按季</router-link></li>
            <li :class="time_type === 'month' ? 'onCur' : ''"><router-link tag="a" :to="'/publicity-' + data_type + '-' + frequency + '-' + start_year + '-month'">按月</router-link></li>
          </ul>
          <span>起始时间：</span>
          <ul>
            <li :class="start_year === 2018 ? 'onCur' : ''"><router-link tag="a" :to="'/publicity-' + data_type + '-' + frequency + '-2018-' + time_type">2018</router-link></li>
            <li :class="start_year === 2019 ? 'onCur' : ''"><router-link tag="a" :to="'/publicity-' + data_type + '-' + frequency + '-2019-' + time_type">2019</router-link></li>
            <li :class="start_year === 2020 ? 'onCur' : ''"><router-link tag="a" :to="'/publicity-' + data_type + '-' + frequency + '-2020-' + time_type">2020</router-link></li>
          </ul>
          <span>动画速度：</span>
          <ul>
            <li :class="frequency === 1000 ? 'onCur' : ''"><router-link tag="a" :to="'/publicity-' + data_type + '-1000-' + start_year + '-' + time_type">低速</router-link></li>
            <li :class="frequency === 500 ? 'onCur' : ''"><router-link tag="a" :to="'/publicity-' + data_type + '-500-' + start_year + '-' + time_type">中速</router-link></li>
            <li :class="frequency === 300 ? 'onCur' : ''"><router-link tag="a" :to="'/publicity-' + data_type + '-300-' + start_year + '-' + time_type">高速</router-link></li>
          </ul>
          <!-- <div class="fotBut"><a href="#">取消</a><a href="#">取消</a></div> -->
        </div>
      </div>
    </div>
    <div class="nav">
      <div class="navLeft">
        <ul>
          <!-- <li class="onCur"><a href="#">按省</a></li> -->
          <li :class="data_type === 'origin' ? 'onCur' : ''">
            <router-link
              tag="a"
              :to="
                '/publicity-origin-' +
                frequency +
                '-' +
                start_year +
                '-' +
                time_type
              "
              >按派系</router-link
            >
          </li>
          <li :class="data_type === 'manufacturer' ? 'onCur' : ''">
            <router-link
              tag="a"
              :to="
                '/publicity-manufacturer-' +
                frequency +
                '-' +
                start_year +
                '-' +
                time_type
              "
              >按车企</router-link
            >
          </li>
          <li :class="data_type === 'modelline' ? 'onCur' : ''">
            <router-link
              tag="a"
              :to="
                '/publicity-modelline-' +
                frequency +
                '-' +
                start_year +
                '-' +
                time_type
              "
              >按车系</router-link
            >
          </li>
          <li :class="data_type === 'brand' ? 'onCur' : ''">
            <router-link
              tag="a"
              :to="
                '/publicity-brand-' +
                frequency +
                '-' +
                start_year +
                '-' +
                time_type
              "
              >按品牌</router-link
            >
          </li>
        </ul>
        <ul class="byyear">
          <li :class="time_type.toLowerCase() === 'year' ? 'onCur' : ''"><router-link tag="a" :to="'/publicity-' + data_type +'-' +frequency +'-' + start_year +'-' + 'year'">按年</router-link></li>
          <li :class="time_type.toLowerCase() === 'quarter' ? 'onCur' : ''"><router-link tag="a" :to="'/publicity-' + data_type +'-'  +frequency +'-' + start_year +'-' + 'quarter'">按季</router-link></li>
          <li :class="time_type.toLowerCase() === 'month' ? 'onCur' : ''"><router-link tag="a" :to="'/publicity-' + data_type +'-'  +frequency +'-' + start_year +'-' + 'month'">按月</router-link></li>
        </ul>
      </div>
      <!--navLeft-->
      <div class="navMiddle">
        <select-lable v-model="start_year" text="起始时间" :selected_text="start_year" :options="options.start_year" optionStyle="sLayer s01" @reset="route_to" />
        <select-lable v-model="mobile_mode"  text="比例" :selected_text="mobile_mode ? '9:16' : '16:9'" :options="options.proportion" optionStyle="sLayer s02" @reset="route_to"/>
        <select-lable v-model="frequency" text="速度" :selected_text="frequency_text"  :options="options.speed" optionStyle="sLayer s03" @reset="route_to"/>
      </div>
      <!--navMiddle-->
      <div class="navRight">
        <ul>
          <li class="blueButton">
            <a href="javascript:;" @click="show()">获取视频</a>
          </li>
          <li><a href="javascript:;" @click="show()">导出Excel</a></li>
        </ul>
      </div>
      <!--navRight-->
    </div>
    <div :class="mobile_mode ? 'box s9-16' : 'box'">
      <div class="chart">
        <bar-race
          :volume_data="volume"
          :title="title"
          :data_type="data_type"
          :time_type="time_type"
          :frequency="frequency"
          :mobile_mode="mobile_mode"
          :is_record="mode === 'record'"
          :key="bar_race_id"
        />
      </div>
    </div>

    <div class="bottomBut">
      <a href="javascript:;" @click="show()">导出Excel</a>
      <a href="javascript:;" @click="show()" class="blue">获取视频</a>
    </div>
  </div>
</template>

<script>
import BarRace from "@/components/echarts/bar-race-charts";
import SelectLable from '@/components/select/select-lable';
import "@/assets/css/publicity.css";

export default {
  name: "publicity",
  components: {
    BarRace,
    SelectLable,
  },
  data() {
    return {
      volume: {},
      title: "",
      title_template: "{year_text}{data_text}排行变化",
      data_text: "",
      data_type: "origin",
      time_type: "month", // quarter
      start_year: 0,
      mode: "",
      frequency: 1000,
      advert: {
        title: "",
        logo: "",
      },
      options:{
        start_year: [{ value: 2018, text:"2018"},{ value: 2019, text:"2019"},{ value: 2020, text:"2020"}],
        proportion: [{ value: false, text:"16:9"},{ value: true, text:"9:16"}],
        speed: [{ value: 1000, text:"低速"},{ value: 500, text:"中速"},{ value: 300, text:"高速"}]
      },
      layer_show: false,
      menu_show: false,
      // 宽度小于640自适应视图
      mobile_mode: false,
      bar_race_id: +new Date(),
    };
  },
  watch: {
    $route(new_val) {
      this.mode = new_val.params.mode;
      this.data_type = new_val.params.data_type
        ? new_val.params.data_type.toLowerCase()
        : this.data_type;
      this.time_type = new_val.params.time_type
        ? new_val.params.time_type.toLowerCase()
        : this.time_type;
      this.frequency = new_val.params.frequency
        ? Number(new_val.params.frequency)
        : this.frequency;
      this.start_year = !isNaN(Number(new_val.params.start_year))
        ? Number(new_val.params.start_year)
        : this.start_year;
      this.init();
    },
    mobile_mode(new_val, old_val) {
      if (new_val != old_val) this.bar_race_id = +new Date();
    },
  },
  computed: {
    frequency_text() {
      switch(this.frequency){
        case 1000 :
          return "低速";
        case 500 :
          return "中速";
        case 300 :
          return "高速";
        default :
          return "其他";
          //value: 1000, text:"低速"},{ value: 500, text:"中速"},{ value: 300, text:"高速"
      }
    },
  },
  mounted() {
    let _this = this;
    this.mode = this.$route.params.mode;
    this.data_type = this.$route.params.data_type
      ? this.$route.params.data_type.toLowerCase()
      : this.data_type;
    this.time_type = this.$route.params.time_type
      ? this.$route.params.time_type.toLowerCase()
      : this.time_type;
    this.frequency = this.$route.params.frequency
      ? Number(this.$route.params.frequency)
      : this.frequency;
    this.start_year = !isNaN(Number(this.$route.params.start_year))
      ? Number(this.$route.params.start_year)
      : this.start_year;
    this.init();
    this.init_advert();
    window.screenWidth = document.body.clientWidth;
    _this.mobile_mode = window.screenWidth <= 640;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        _this.mobile_mode = window.screenWidth <= 640;
      })();
    };
  },
  methods: {
    init() {
      let _this = this;
      this.$http({
        url: "/home/race",
        method: "get",
        crossdomain: true,
        params: {
          dataType: _this.data_type,
          timeType: _this.time_type,
          year: _this.start_year,
        },
      })
        .then(function (res) {
          _this.volume = res.data;
          console.log(_this.volume.list)
          _this.switch_type();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    init_advert() {
      let _this = this;
      this.$http({
        url: "/home/advert",
        method: "get",
        crossdomain: true,
      })
        .then(function (res) {
          _this.advert.title = res.data.title;
          _this.advert.logo = res.data.logo;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    switch_type() {
      let _this = this;
      switch (this.data_type) {
        case "origin":
          this.data_text = "派系";
          break;
        case "manufacturer":
          this.data_text = "车企";
          break;
        case "modelline":
          this.data_text = "车系";
          break;
        case "brand":
          this.data_text = "品牌";
          break;
      }
      if (
        _this.volume.dates[0].yearDate ===
        _this.volume.dates[_this.volume.dates.length - 1].yearDate
      ) {
        _this.title = _this.title_template.replace(
          "{year_text}",
          _this.volume.dates[0].yearDate + "年"
        );
      } else {
        _this.title = _this.title_template.replace(
          "{year_text}",
          _this.volume.dates[0].yearDate +
            "年至" +
            this.volume.dates[_this.volume.dates.length - 1].yearDate +
            "年"
        );
      }
      _this.title = _this.title.replace("{data_text}", _this.data_text);
    },
    show() {
      this.layer_show = true;
    },
    hide() {
      this.layer_show = false;
    },
    route_to() {
      this.$router.push({path: 'publicity-' + this.data_type +'-' + this.frequency +'-' + this.start_year +'-' + this.time_type })
    }
  },
};
</script>